"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react');




var _actions = require('shared/actions'); var _actions2 = _interopRequireDefault(_actions);
var _actionCreators = require('shared/actions/actionCreators'); var _actionCreators2 = _interopRequireDefault(_actionCreators);
var _useBus = require('shared/hooks/useBus'); var _useBus2 = _interopRequireDefault(_useBus);
var _helpers = require('web/screens/Broadcast/Wizard/helpers');
var _addingRecipients = require('web/screens/Broadcast/addingRecipients');

 const PAGE_SIZE = 50; exports.PAGE_SIZE = PAGE_SIZE

/* What the toolbar's filter can show: everyone, the rows that will be sent,
 * the rows that need attention, or (once sending has started) one message
 * status. blocked is the campaign page's review of the unsent recipients the
 * launch gate would refuse (P3'). */







 const ALL = { kind: 'all' }; exports.ALL = ALL















/* Anything that changes who's in the campaign or what their rows say. */
const RELOAD_ON = [
  _actionCreators2.default.addCampaignRecipientsActions.SUCCESS.type,
  // The picker's Add, and one that failed partway (each chunk commits).
  _actionCreators2.default.addPatientPickToBroadcastActions.SUCCESS.type,
  _actionCreators2.default.addPatientPickToBroadcastActions.FAILURE.type,
  _actionCreators2.default.removePatientsFromCampaignActions.SUCCESS.type,
  _actionCreators2.default.dequeuePatientsInCampaignActions.SUCCESS.type,
  _actionCreators2.default.addPatientsToCampaignActions.SUCCESS.type,
  _actionCreators2.default.startCampaignActions.SUCCESS.type,
  _actionCreators2.default.stopCampaignActions.SUCCESS.type,
  _actionCreators2.default.updateCampaignActions.SUCCESS.type,
  _actionCreators2.default.addCampaignVariableActions.SUCCESS.type,
  _actionCreators2.default.updateCampaignVariableActions.SUCCESS.type,
  _actionCreators2.default.removeCampaignVariableActions.SUCCESS.type,
  _actionCreators2.default.updateCampaignRecipientValuesActions.SUCCESS.type,
]

// A patient's details changed in the directory (Edit patient's Save details):
// their row's contact and readiness are read again, fresh (review R800-71).
const RELOAD_FRESH_ON = [_actionCreators2.default.updatePatientActions.SUCCESS.type]

// While messages go out, the rows are re-read at most this often.
const PROGRESS_RELOAD_MS = 3000

const PROGRESS = [_actionCreators2.default.campaignProgressNotificationAction.type]

const countsOf = (p) => ({
  all: p.FilterCounts.all,
  ready: _nullishCoalesce(p.FilterCounts.ready, () => ( 0)),
  attention: _nullishCoalesce(p.FilterCounts.attention, () => ( 0)),
  blocked: _nullishCoalesce(p.FilterCounts.blocked, () => ( 0)),
})

/* Rev 31 v2: one page of a campaign's recipients for the shared screen,
 * from the recipients preview's whole-audience view (saved rows only: Add
 * saves at once, so nothing is pending). Re-read when the campaign's
 * recipients, variables or message change; an older answer never replaces
 * a newer one. */
const useRecipientsView = (
  campaign,
  filter,
  search,
  offset,
) => {
  const { CampaignKey, MessageTemplate } = campaign
  const [state, setState] = _react.useState({ view: null, counts: null, isLoading: true, error: null })
  const [version, setVersion] = _react.useState.call(void 0, 0)
  const reload = _react.useCallback.call(void 0, () => setVersion(v => v + 1), [])
  _useBus2.default.call(void 0, RELOAD_ON, reload)
  const isNextFresh = _react.useRef.call(void 0, false)
  const reloadFresh = _react.useCallback.call(void 0, () => {
    isNextFresh.current = true
    reload()
  }, [reload])
  _useBus2.default.call(void 0, RELOAD_FRESH_ON, reloadFresh)

  // A progress notification for this campaign re-reads the page, throttled.
  const progressTimer = _react.useRef(null)
  const onProgress = _react.useCallback.call(void 0, 
    (action) => {
      const campaignKey = _optionalChain([(action ), 'access', _ => _.payload, 'optionalAccess', _2 => _2.CampaignKey])
      if (campaignKey !== CampaignKey || progressTimer.current) return
      progressTimer.current = setTimeout(() => {
        progressTimer.current = null
        reload()
      }, PROGRESS_RELOAD_MS)
    },
    [CampaignKey, reload],
  )
  _useBus2.default.call(void 0, PROGRESS, onProgress)
  _react.useEffect.call(void 0, () => () => { if (progressTimer.current) clearTimeout(progressTimer.current) }, [])

  // P2' (review F-2, F-3): when a background Add into this campaign ends,
  // its rows are read again fresh. The worker may have changed only values,
  // which the server's cached view can't tell from its recipient count. The
  // end comes as a push or, after a reconnect that missed it, from the
  // status read; both land in the store.
  const add = _addingRecipients.useRecipientsAdd.call(void 0, CampaignKey)
  const endedAdd = add && add.State !== 'running' ? add.TaskKey : null
  const seenEnd = _react.useRef.call(void 0, endedAdd)
  _react.useEffect.call(void 0, 
    () => {
      if (endedAdd && endedAdd !== seenEnd.current) reloadFresh()
      seenEnd.current = endedAdd
    },
    [endedAdd, reloadFresh],
  )

  const latest = _react.useRef.call(void 0, 0)
  _react.useEffect.call(void 0, 
    () => {
      const ask = ++latest.current
      const isFresh = isNextFresh.current
      isNextFresh.current = false
      setState(s => ({ ...s, isLoading: true }))
      _actions2.default.previewCampaignRecipients({
        CampaignKey,
        Sources: [],
        View: {
          Offset: offset,
          Limit: exports.PAGE_SIZE,
          Filter: filter.kind === 'status' ? 'all' : filter.kind,
          ...(filter.kind === 'status' ? { Status: filter.status } : {}),
          ...(search ? { Search: search } : {}),
          IncludeSaved: true,
          ...(isFresh ? { Fresh: true } : {}),
        },
      })
        .then(p => {
          if (ask === latest.current) setState({ view: p.View, counts: countsOf(p), isLoading: false, error: null })
        })
        .catch((e) => {
          if (ask === latest.current) setState(s => ({ ...s, isLoading: false, error: _helpers.errorText.call(void 0, e, "Couldn't load the recipients") }))
        })
    },
    // The message decides which values are missing.
    [CampaignKey, MessageTemplate, filter, search, offset, version],
  )

  return { ...state, reload }
}

exports. default = useRecipientsView
